// exportEntries.js

function formatEntryForExport(entry) {
  const formatted = { ...entry };

  for (const key in formatted) {
    const value = formatted[key];

    if (value?.toDate) {
      formatted[key] = value.toDate().toISOString().slice(0, 19).replace("T", " ");
    } else if (value instanceof Date) {
      formatted[key] = value.toISOString().slice(0, 19).replace("T", " ");
    }
  }

  return formatted;
}

export function exportEntriesToJson(entries = []) {
  const formattedEntries = entries.map(formatEntryForExport);

  const jsonString = JSON.stringify(formattedEntries, null, 2);

  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "entries.json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  URL.revokeObjectURL(url);
}